import React from 'react';
import styled from 'styled-components';

/**
* Styled components
*/
const PerceptionItemHeader = styled.div`
  position: relative;
`;

const PerceptionValue = styled.p`
  text-align: center;
  margin-bottom: 4px;
  font-weight: normal;
  color: #c3c3c3;
`;

const HighProcentageArrow = styled.span`
  display: none;
  position: absolute;
  top: -1px;
  right: -25px;
  background-color: #fff;
  padding: 3px 4px;
  border-radius: 20px;
  color: #333;
`;

const ProgressHead = styled.div`
  margin: 0 auto;
  display: flex;
  width: 100%;
  max-width: 80px;
  padding-top: 0px;
  padding-bottom: 3px;

  svg {
    flex: 1;
    padding: 1px 1px 0 1px;
  }

  @media only screen and (max-width: 991px), print {
    display: block;
  }
`;

const PerceptionStatus = styled.p`
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 0px;
  font-weight: normal;
  margin-top: 4px;
  color: #c3c3c3;
`;


/**
* Stateless component PerceptionItem
*/
const PerceptionItem = ({ perceptionValue, perceptionStatus, perceptionColor, perceptionReport}) => {
  let perceptionStatusUppercase = perceptionStatus.charAt(0).toUpperCase() + perceptionStatus.slice(1);

  return (
    <div>
      <PerceptionItemHeader>
        <PerceptionValue className={perceptionReport ? 'normal-font-size' : 'big-font-size'}>{perceptionValue}%</PerceptionValue>
        {perceptionReport && perceptionValue > 50 ? <HighProcentageArrow className="tiny-font-size">High procentage</HighProcentageArrow> : ''}
      </PerceptionItemHeader>
      <ProgressHead>
        <svg version="1.1" id={`svg${perceptionStatusUppercase}Head`} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="6783.5 2408 274.43 240.126" xmlSpace="preserve">
          <defs>
            <linearGradient id={`grad${perceptionStatusUppercase}Head`} x1="50%" y1="0%" x2="50%" y2="100%">
              <stop id={`stop${perceptionStatusUppercase}Head_1`} offset={1-(perceptionValue/100)} stopColor="black" stopOpacity="0">
                <animate id={`animStop${perceptionStatusUppercase}Head`} attributeName="offset" values={`1;${1-(perceptionValue/100)}`} dur="0.8s"></animate>
              </stop>
              <stop id={`stop${perceptionStatusUppercase}Head_2`} offset={`${100 - perceptionValue}%`} stopColor={perceptionColor}></stop>
            </linearGradient>
          </defs>
          <g stroke="white">
            <path fill={`url(#grad${perceptionStatusUppercase}Head)`} d="M141.215,151.215A68.607,68.607,0,1,0,72.607,82.607,68.589,68.589,0,0,0,141.215,151.215Zm0,0C95.419,151.215,4,174.2,4,219.822v34.3H278.43v-34.3C278.43,174.2,187.01,151.215,141.215,151.215Z" transform="translate(6779.5 2394)" strokeWidth={perceptionValue > 50 && perceptionReport ? "6" : "2"}></path>
          </g>
        </svg>
      </ProgressHead>
      <PerceptionStatus className="small-font-size">{perceptionStatus}</PerceptionStatus>
    </div>
  );
}

export default PerceptionItem;



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/PerceptionItem.js